import { IZone, IZoneTree } from "interfaces/zone.interface";

const buildTree = (
  zones: IZoneTree[],
  parentId: string | null = null,
): IZoneTree[] => {
  const filteredZones = zones.filter(
    (item: IZone) => item.parent_id === parentId,
  );

  return filteredZones.map((item) => {
    const children = buildTree(zones, item.id);

    if (children.length === 0) return item;

    return { ...item, children };
  });
};

export const makeZoneTree = (data: IZone[]): IZoneTree[] =>
  buildTree(
    data.toSorted((a, b) =>
      Intl.Collator("nb", { sensitivity: "base" }).compare(
        a.name.toLocaleLowerCase(),
        b.name.toLocaleLowerCase(),
      ),
    ),
  );
